import { render, staticRenderFns } from "./category-select.vue?vue&type=template&id=4f2fd41c"
import script from "./category-select.vue?vue&type=script&lang=js"
export * from "./category-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports